<template>
  <div class="col-md-8 col-sm-12">
    <ul class="row" v-if="posts">
      <li class="col-md-12" v-for="(post, index) in posts" :key="index">
        <div class="box">
          <div class="garden-img-full-width garden-overlay-scale">
            <router-link
              :to="{
                name: 'SinglePost',
                params: {
                  type: type,
                  slug: `${post.slug}`
                }
              }"
            >
              <img :src="post.featuredImage" :alt="post.title" />
            </router-link>
            <div class="garden-overlay">
              <div class="garden-button">
                <router-link
                  :to="{
                    name: 'SinglePost',
                    params: {
                      type: type,
                      slug: `${post.slug}`
                    }
                  }"
                  >{{ $t("readMore") }}</router-link
                >
              </div>
            </div>
          </div>
          <!-- <h6>Catégorie: {{post.blog}}</h6> -->
          <div class="meta">
            <ul>
              <li>
                <p v-if="post.chargerDuProjet">
                  <span class="fa fa-user"></span>
                  {{ post.chargerDuProjet }}
                </p>
                <p v-else>
                  <span class="fa fa-user"></span>
                  Afrik Eveil
                </p>
              </li>
              <li>
                <p>
                  <span class="fa fa-calendar"></span>
                  {{ format_date(post.created_at) }}
                </p>
              </li>
              <li>
                <p>
                  <span class="fa fa-clock-o"></span>
                  <timeago
                    :datetime="post.created_at"
                    :locale="locale"
                  ></timeago>
                </p>
              </li>
            </ul>
          </div>
          <router-link
            :to="{
              name: 'SinglePost',
              params: {
                type: type,
                slug: `${post.slug}`
              }
            }"
            class="garden-hv-child-color-primary"
          >
            <h3>{{ post.title }}</h3>
          </router-link>
          <p v-html="post.content.substring(0, 550)">....</p>
          <router-link
            :to="{
              name: 'SinglePost',
              params: {
                type: type,
                slug: `${post.slug}`
              }
            }"
            class="btn btn-md readMore"
          >
            {{ $t("readMore") }}{{ " " }}
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
export default {
  watch: {
    $route() {
      this.getLang();
      this.format_date();
    }
  },
  data() {
    return {
      locale: ""
    };
  },
  name: "ourNews",
  methods: {
    getLang() {
      this.locale = this.$i18n.locale;
      this.postArticles = this.articles;
      this.postPagination = this.pagination;
    },
    format_date(value) {
      if (value) {
        if (this.$i18n.locale == "en") {
          return moment(String(value)).format("MM/DD/YYYY");
        } else {
          return moment(String(value)).format("DD/MM/YYYY");
        }
      }
    }
  },
  props: {
    posts: {},
    pagination: {},
    type: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.garden-img-full-width img {
  border-radius: 20px;
}
.blog {
  margin-top: -60px;
}
.box {
  margin-bottom: 20px !important;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-bottom: 5px solid #fff;
}
.box:hover {
  border-bottom: 5px solid #228c4f;
}

.box:hover {
  border-bottom: 5px solid #228c4f;
}
.title a {
  /* border: 2px solid red; */
  height: 60px;
  display: block;
  margin-bottom: 0px;
  font-size: 15px;
  color: #228c4f;
}
.readMore {
  width: 85% !important;
  background: #228c4f;
  line-height: 20px !important;
  margin: 15px;
  padding: 10px !important;
  text-align: center;
  color: #fff;
  border: 2px solid transparent;
  font-size: 18px;
  font-weight: 500;
  margin-left: 50px !important;
  border-radius: 8px;
}
.readMore:hover {
  color: #fbec64;
  border: 2px solid #fbec64;
  background: #104627;
}
.garden-img-full-width img,
.garden-overlay {
  border-radius: 8px;
}
.garden-img-full-width img {
  width: 100%;
  position: relative;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.meta {
  border: 1px dashed #228c4f;
  border-radius: 33px;
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.content {
  font-size: 13px !important;
  color: #000;
  font-weight: 400;
  text-align: justify;
}
.meta li {
  display: inline-block;
  padding-left: 106px;
  margin-bottom: 0px !important;
}
.meta li p {
  font-size: 12px;
  color: #4e5453;
  font-weight: 400;
}
.meta li p span {
  padding-right: 7px;
  color: #228c4f;
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .meta li {
    padding-left: 3px;
  }
  .meta li p {
    font-size: 13px !important;
  }
  .readMore {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .box h3 {
    font-size: 15px !important;
    text-align: center;
  }
  .box p {
    font-size: 11px !important;
    text-align: justify;
  }
}
@media (max-device-width: 320px) {
  .meta li {
    padding-left: 5px;
  }
  .meta li p {
    font-size: 10px !important;
  }
  .readMore {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .box h3 {
    font-size: 13px !important;
    text-align: center;
  }
  .box p {
    font-size: 11px !important;
    text-align: justify;
  }
}
</style>
